module.exports = __webpack_public_path__ + "img/icon@2x.2b481586.png";